var React = require('react');

function Warning (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M10.943 2.223c.408.204.739.535.943.943l5.89 11.782c.522 1.042.1 2.309-.942 2.83-.293.146-.616.222-.943.222H4.109C2.944 18 2 17.056 2 15.891c0-.327.076-.65.223-.943l5.89-11.782c.522-1.042 1.788-1.464 2.83-.943zM10 14c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zm0-8c-.513 0-.936.386-.993.883L9 7v4c0 .552.448 1 1 1 .513 0 .936-.386.993-.883L11 11V7c0-.552-.448-1-1-1z"}));
}

Warning.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20"};

module.exports = Warning;

Warning.default = Warning;
